import * as t from '../actionTypes';

export const loadPlacementTestReportCardRequest = payload => ({
  type: t.DOWNLOAD_PLACEMENT_TEST_REPORT_CARD,
  payload
});

export const downloadPlacementTestReportCardSuccess = payload => ({
  type: t.DOWNLOAD_PLACEMENT_TEST_REPORT_CARD_SUCCESS,
  payload
});

export const downloadPlacementTestReportCardFailure = payload => ({
  type: t.DOWNLOAD_PLACEMENT_TEST_REPORT_CARD_FAILURE,
  payload
});
